export default __webpack_public_path__ + "static/media/giftcard-banner.e6f45544.png";